// extracted by mini-css-extract-plugin
module.exports = {"list":"panel_list_2QsCY"};